module.exports = __webpack_public_path__ + "static/media/bentley-go-drive.3d2e7827.png";